//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'c_checkbox_group',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  data: function data() {
    return {
      formData: {
        type: 0
      },
      defaults: {},
      configData: {}
    };
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
    });
  },
  methods: {
    radioChange: function radioChange(e) {
      this.$emit('getConfig', {
        name: 'checkbox_group',
        values: e
      });
    }
  }
};